import { contractsService } from '@/services/contracts-service'
import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

/**
 * Hook to calculate iva and total amount
 * @param {number} defaultTotalAmountCents
 */
export const useSimpleCalculator = ({ defaultTotalAmountCents }) => {
  const [amounts, setAmounts] = useState({
    totalAmountCents: defaultTotalAmountCents || 0,
    ivaAmountCents: defaultTotalAmountCents * 0.19 || 0,
    netAmountCents: defaultTotalAmountCents / 1.19 || 0
  })

  useEffect(() => {
    if (amounts.netAmountCents < 1) return

    contractsService.calculate({ net_amount_cents: amounts.netAmountCents }).then(({ data }) => {
      const {
        ivaAmountCents,
        totalAmountCents
      } = data

      setAmounts(
        Object.assign({}, amounts, {
          totalAmountCents,
          ivaAmountCents
        })
      )
    })
  }, [amounts.netAmountCents])

  /**
   * @param {number} value
   * @returns {function}
   */
  const handleNetAmount = (value) => {
    setAmounts(
      Object.assign({}, amounts, {
        netAmountCents: value
      })
    )
  }

  return {
    amounts,
    handleNetAmount
  }
}

useSimpleCalculator.propTypes = {
  netAmount: PropTypes.number.isRequired,
  defaultTotalAmount: PropTypes.number
}

useSimpleCalculator.defaultProps = {
  defaultTotalAmount: 0
}
